import { StatsDataOutput } from '@/graphql/generated';
import { StatsCard } from '../molecules';
import { useUserLanguage } from '@/customHooks';
import textsData from '@/textData/DashboardTexts.json';
import papersIcon from '@/assets/dashboard-icons/papers-icon.svg';
import personIcon from '@/assets/dashboard-icons/person-icon.svg';
import houseIcon from '@/assets/dashboard-icons/house-icon.svg';
import contractIcon from '@/assets/dashboard-icons/contract-icon.svg';
import { pathURL } from '@/components/constants/urls';

type DashboardStatsSectionProps = {
  data: StatsDataOutput | undefined;
};

const emptyData: StatsDataOutput = {
  incidents: '0',
  properties: '0',
  tenants: '0',
  owners: '0',
};

const userBase = `/${pathURL.USER}`;

export const DashboardStatsSection = ({ data }: DashboardStatsSectionProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.statsCards : textsData.en.statsCards;

  const stats = [
    {
      label: texts.card1,
      value: data?.properties ?? emptyData.properties,
      iconSrc: papersIcon,
      to: `${userBase}/${pathURL.PROPERTY}`,
    },
    {
      label: texts.card2,
      value: data?.tenants ?? emptyData.tenants,
      iconSrc: personIcon,
      to: `${userBase}/${pathURL.TENANT}`,
    },
    {
      label: texts.card3,
      value: data?.owners ?? emptyData.owners,
      iconSrc: houseIcon,
      to: `${userBase}/${pathURL.OWNER}`,
    },
    {
      label: texts.card4,
      value: data?.incidents ?? emptyData.incidents,
      iconSrc: contractIcon,
      to: `${userBase}/${pathURL.INCIDENTS}`,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.to} className="min-w-0">
          <StatsCard {...stat} />
        </div>
      ))}
    </div>
  );
};
